<template>
  <div
    id="editor"
    @click.stop=""
  >
    <div>
      <div class="col-sm-12 form-data">
        <h4 class="editor-header">
          {{ $t('contracts.basic_info') }}
        </h4>

        <coordinate-editor
          v-if="showLocation"
          v-model="location"
          size="sm"
          :point-type="OTHER"
          :title="$t('material_station.location')"
          @set-location="saveLocation"
          @close="saveLocation(null)"
        />

        <div class="row">
          <div class="col-sm-6 px-2">
            <span class="span-title">
              {{ $t('contract_user_reports.choose_date') }}
            </span>
            <date-time-picker
              v-model:date="dangerDate"
              class="routa-input"
              format="dd.MM.yyyy HH:mm"
              :enableTimePicker="true"
              :placeholder="$t('observations_videos.search_input_format')"
            />
          </div>

          <div class="col-sm-6 px-2">
              <span class="span-title">
                {{ $t('danger_report.select_event_type') }}
              </span>
              <select
                  id="danger_type"
                  v-model="danger_type"
                  class="form-select form-select-sm"
              >
                  <option :value="null" disabled>
                      {{ $t('danger_report.danger_type') }}
                  </option>
                  <option
                      v-for="result in danger_types"
                      :key="result"
                      :value="result"
                  >
                      {{ getDangerTypeName(result) }}
                  </option>
              </select>
          </div>
        </div>

        <open-contract-filter
          v-if="!selectedContract"
          :from="fromDate"
          :to="toDate"
          :contract="contract"
          :show-only-my-contracts-option="true"
          :show-title="true"
          :show-company="false"
          @contract-selected="setContract"
        />

        <span class="span-title">{{ $t('common.description') }}</span>
          <textarea
              id="info"
              v-model="description"
              class="form-control"
              rows="3"
              style="resize: vertical; max-height: calc(1.5em * 6);"
          ></textarea>

        <span class="span-title">{{ $t('danger_report.description_conditions') }}</span>
          <textarea
              id="cause"
              v-model="cause"
              class="form-control"
              rows="3"
              style="resize: vertical; max-height: calc(1.5em * 6);"
          ></textarea>

        <span class="span-title">{{ $t('danger_report.proposal_for_preventive_actions') }}</span>
          <textarea
              id="prevent"
              v-model="prevent"
              class="form-control"
              rows="3"
              style="resize: vertical; max-height: calc(1.5em * 6);"
          ></textarea>

        <div class="col-md-12 nopads p-1">
          <span class="span-title">
            {{ $t('danger_report.consequences.title') }}
          </span>
            <select
                id="consequence_type"
                v-model="consequence_type"
                class="form-select form-select-sm"
            >
                <option
                    :value="null"
                    disabled
                >
                    {{ $t('danger_report.consequences.select') }}
                </option>
                <option
                    v-for="result in consequence_types"
                    :key="result"
                    :value="result"
                >
                    {{ getDangerConsequencesName(result) }}
                </option>
            </select>
        </div>

        <span class="span-title">{{ $t('danger_report.consequences.info') }}</span>
          <textarea
              v-model="conse_description"
              class="form-control"
              rows="3"
              style="resize: vertical; max-height: calc(1.5em * 6);"
          ></textarea>

          <span class="span-title">{{ $t('danger_report.informing') }}</span>
          <textarea
              id="prevent"
              v-model="informing"
              class="form-control"
              rows="3"
              style="resize: vertical; max-height: calc(1.5em * 6);"
          ></textarea>

        <!--Todo allow easily remove photos-->
          <!-- Photo editor-->
          <div class="col-12 my-3">
              <!-- Show selected photos -->
              <div
                  v-for="(file, index) in photos"
                  :key="index"
                  class="d-flex align-items-center justify-content-between mb-3"
              >
                  <span>{{ file?.name || file }}</span>
                  <button
                      class="btn btn-outline-danger btn-sm"
                      type="button"
                      @click="removePhoto(index)"
                  >
                      {{ $t('common.remove') }}
                  </button>
              </div>

              <!-- Hidden file input -->
              <input
                  ref="photoInput"
                  type="file"
                  accept="image/jpeg,image/jpg,image/png"
                  class="visually-hidden"
                  @change="handlePhotoChange"
              />

              <!-- Custom "Add photo" button -->
              <div class="col-12 d-flex justify-content-end">
                  <button
                      class="btn btn-outline-primary btn-sm"
                      type="button"
                      @click="triggerPhotoInput"
                  >
                      {{ $t('power_stations.add_photo') }}
                  </button>
              </div>
          </div>

        <div class="col-sm-12 button-container">
          <button
            class="btn btn-secondary form-button"
            @click.stop="$emit('close')"
          >
              {{ $t('common.cancel') }}
          </button>
          <button
            class="btn btn-success form-button"
            :disabled="loading"
            @click.stop="submitReport"
          >
              {{ $t('common.save') }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from '../mixins/TimeUtils'
import {mapHelper} from "@/components/mixins/MapMixin";
import CoordinateEditor from "@/components/CoordinateEditor.vue";
import {dangerHelper} from "@/components/mixins/DangerMixin";
import {attachmentHelper} from "@/components/mixins/AttachmentMixin"
import OpenContractFilter from "@/components/contract/OpenContractFilter.vue";
import DateTimePicker from "@/components/common/DateTimePicker";
import {inject} from "vue";

export default {
    name: 'DangerReportForm',
    components: {OpenContractFilter, CoordinateEditor, DateTimePicker},
    mixins: [restApi, timeUtils, mapHelper, attachmentHelper, dangerHelper],
    props: {
        coordinates: {
            type: Object,
            default: null
        },
        showLocation: {
            type: Boolean,
            default() {
                return false
            }
        },
        selectedContract: {
            type: Object,
            default: null
        },
        showReport: Boolean
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            fromDate: null,
            toDate: null,
            contract: null,
            location: this.coordinates === null ? {"y": 63.6, "x": 26.5} : this.coordinates,
            loading: false,
            photos: [],
            dangerDate: null,
            prevent: null,
            cause: null,
            conse_description: null,
            description: null,
            danger_types: [
                1,
                2,
                3
            ],
            danger_type: null,
            consequence_types: [
                1,
                2,
                3,
                4,
                5,
                6
            ],
            consequence_type: null,
            dangerReportUpdate: null,
            informing: null
        }
    },

    mounted: function () {
        if (!this.fromDate) {
            this.fromDate = this.getMonthStart()
        }
        if (this.selectedContract) {
            this.contract = this.selectedContract
        } else {
            this.fetchContracts()
        }
        this.companyPlaceholder = this.$t('trip_list.search_select_contract_first')
    },

    methods: {
        triggerPhotoInput() {
            this.$refs.photoInput?.click();
        },
        handlePhotoChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.photos.push(file);
            }
            // Clear input value so the same file can be selected again if needed
            event.target.value = '';
        },
        removePhoto(index) {
            this.photos.splice(index, 1);
        },


        setContract: function (contract) {
            this.contract = contract ? contract : null
            this.getContractCompanies()
        },

        getContractCompanies: function () {
            this.companyOptions = []
            this.companyParam = null
            this.companyPlaceholder = this.$t('trip_list.search_select_contract_first')
            if (this.contract) {
                this.restFetchParams(this.contractCompanyUrl, {contract: this.contract.id}, this.handleContractCompanies)
            }
        },

        handleContractCompanies: function (response) {
            if (response && response.data) {
                this.companyPlaceholder = this.$t('')
                response.data.forEach(company => {
                    this.companyOptions.push({name: company.name, value: company.id})
                })
                this.companyPlaceholder = this.$t('users.select_company')
            }
            this.loading = false
        },

        fetchContracts: function () {
            this.loading = true
            this.restFetch(this.contractOpenUrl , this.handleResponse)
        },

        handleResponse: function (response) {
            this.loading = false
            this.contracts = response.data
        },

        saveLocation: function (loc) {
            const location = {}
            location.lat = loc.y
            location.lon = loc.x
            this.location = location
        },

        getDefaultValues: function () {
            const dangerReport = {}
            if (this.location == null) {
                this.showAlert(this.$t('power_stations.error_position'))
                return undefined
            }
            if (this.dangerDate === null || !this.dangerDate) {
                this.showAlert(this.$t('meal_allowance.error_date_missing'))
                return undefined
            }
            if (this.danger_type === null) {
                this.showAlert(this.$t('danger_report.select_event_type'))
                return undefined
            }
            if (this.contract === null) {
                this.showAlert(this.$t('ins_wizard.select_contract'))
                return undefined
            }
            if (this.description === null) {
                this.showAlert(this.$t('danger_report.description_missing'))
                return undefined
            }
            if (this.location) {
                dangerReport.location = this.location
            }
            if (this.dangerDate) {
                dangerReport.event_time = this.dangerDate
            }
            if (this.danger_type) {
                dangerReport.event_type = this.danger_type
            }
            if (this.description) {
                dangerReport.description = this.description
            }
            if (this.cause) {
                dangerReport.description_conditions = this.cause
            }
            if (this.prevent) {
                dangerReport.proposal_for_preventive_actions = this.prevent
            }

            if (this.consequence_type) {
                dangerReport.consequences = this.consequence_type
            }

            if (this.conse_description) {
                dangerReport.consequences_info = this.conse_description
            }
            if (this.informing) {
                dangerReport.informing = this.informing
            }

            if (this.contract) {
                dangerReport.contract = {id: this.contract.id}
            }
            return dangerReport
        },

        submitReport: function () {
            const jsonDangerReport = this.getDefaultValues();
            if (jsonDangerReport) {
                this.loading = true
                this.restAdd(this.dangerReportUrl, jsonDangerReport, this.success, this.fail)
            }
        },

        success: function (response) {
            let photos = this.getValidAttachments(this.photos)
            if (photos.length > 0) {
                this.uploadPhoto(photos, response.id)
            } else {
                this.uploadCompleted()
            }
        },

        resetData: function () {
                this.contract = null
                this.location = null
                this.photos = new Array(5)
                this.dangerDate = null
                this.prevent = null
                this.cause = null
                this.conse_description = null
                this.description = null
                this.danger_type = null
                this.consequence_type = null
                this.dangerReportUpdate = null
                this.$emit('close')
        },

        uploadCompleted: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_add_success'), 'success')
            this.resetData()
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        },

        uploadPhoto: function (photos, id) {
            if (photos.length > 0) {
                this.loading = true
                let formData = new FormData()
                photos.forEach(photoFile => {
                    if (photoFile !== undefined && photoFile !== null) {
                        formData.append('photos[]', photoFile)
                    }
                })
                let url = this.dangerReportUrl + "/" + id + "/photo"
                this.restPostWithFile(url, {}, formData, this.photoSuccess, this.fail)
            }
        },

        photoSuccess: function () {
            this.loading = false
            this.resetData()
            this.showAlert(this.$t('common.alert_add_success'), 'success')
        }
    }
}
</script>
